import React, {useState, useEffect, useMemo, useContext} from 'react';
import ToDoListView from './ToDoListView';
import swal from 'sweetalert';
import Spinner from '../../Spinner/Spinner';
import {getToDoList, deleteToDoList} from '../../../services/MadricService';
import {useParams} from 'react-router-dom';
import {MadricContext} from '../../../Context/MadricContext';

/**
 *  L'accueil
 * @return {JSX}
 */
function ToDoList() {
  const [searchInput, setSearchInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const {id} = useParams();
  const {projectInfoObtained, projectInfo, setProjectInfo} = useContext(MadricContext);

  useEffect(() => {
    if (!projectInfoObtained.current.includes('todolist')) {
      projectInfoObtained.current = [...projectInfoObtained.current, 'todolist'];
      fetchToDoList();
    }
  }, []);


  /**
   * Permet d'allez chercher la liste des chantiers
   */
  async function fetchToDoList() {
    setIsLoading(true);
    const todolists = await getToDoList(id);
    setProjectInfo((prev) => [...prev, ...todolists]);
    setIsLoading(false);
  }

  const filteredToDoList = useMemo(() => {
    return projectInfo
        .filter((item) => item.type === 'todolist')
        .filter((todo) =>
          searchInput
              .toLowerCase()
              .split(' ')
              .every(
                  (term) =>
                    todo.description?.toLowerCase().includes(term),
              ),
        );
  }, [searchInput, projectInfo]);


  /**
   * Permet de gérer la searchBar
   * @param {*} e event
   */
  function handleSearchInput(e) {
    setSearchInput(e.target.value);
  }


  /**
   * Permet de supprimer un chantier
   * @param {*} id id du chantier a supprimer
   */
  async function supprimer(id) {
    swal({
      title: '!! Êtes-vous sûre de vouloir supprimer cette tâche !!',
      text: 'Une fois supprimé vous perderez cette tâche',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    })
        .then(async (willDelete) => {
          if (willDelete) {
            swal('Supprimé!', {
              icon: 'success',
            });

            setProjectInfo((prevItems) => prevItems.filter((item) => item.type === 'todolist' && item.id !== id));
            setIsLoading(true);
            await deleteToDoList(id);
            setIsLoading(false);
          } else {
            swal('Annulé!');
          }
        });
  }

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <ToDoListView
        searchInput={searchInput}
        handleSearchInput={handleSearchInput}
        toDoList={projectInfo.filter((item) => item.type === 'todolist')}
        setToDoList={setProjectInfo}
        displayedToDoList={filteredToDoList}
        supprimer={supprimer} />
    </React.Fragment>
  );
}

export default ToDoList;
